<template>
  <div class="recipe-by">
    <span>Recipe By: </span> 
    <a v-if="sourceUrl" :href="sourceUrl" target="_blank"><em>{{ name }}</em></a>
    <em v-else>{{ name }}</em>
  </div>
</template>

<script>
  export default {
    name: "AddedBy",
    props: {
      id: Number,
      source: String,
      sourceUrl: String
    },
    data: () => ({
      user: []
    }),
    computed: {
      name() {
        return this.source ? this.source : `${this.user.firstName} ${this.user.lastName}`.trim();
      },
    },
    async mounted() {
      try {
        this.user = await this.$service.user.findById(this.id);        
      } catch (e) {
        console.error(`Error loading user`, e);
      }
    },
  };
</script>

<style scoped lang="scss">
  .recipe-by {
    font-size: 14px;
  }
</style>
